<template>
	<div class="body">
		<div class="industry-ctr" v-if="majorData">

			<div class="cnt-nav-ctr">
				<div class="cnt-nav-inner">
					<div class="cnt-nav-item" v-for="(item, index) in navList" :key="index" @click="clickRoute(item)">

						<img :src="item.icon" class="nav-item-icon" />
						<label
							:class="['nav-item-name', index == navList.length - 1 ? 'nav-item-name-selected' : '']">{{ item.name }}</label>

						<img src="http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13144709-98064606215907526.png"
							class="nav-arrow" v-if="index != navList.length - 1" />
					</div>
				</div>
			</div>

			<div class="content-title">
				<img class="title-wing" src="@/assets/icons/title_wing_left.png" />
				<span class="title-text">{{ title }}</span>
				<img class="title-wing" src="@/assets/icons/title_wing_right.png" />
			</div>

			<div class="group-cnt-ctr">
				<div class="left-cnt-ctr">
					<div class="left-cnt">
						<div class="cnt-title-ctr">
							<div class='cnt-title'>{{majorData.title}}</div>
						</div>

						<el-table :data="majorData.list" :span-method="spanMethod" border>
							<el-table-column label="专业名称" align="center" prop="major_name" />
							<el-table-column label="所属行业" align="center" prop="industry_name" />
						</el-table>
					</div>

					<div class='group-arrow-ctr'>
						<img class="group-arrow" src="@/assets/arrow.webp" />
					</div>

				</div>


				<div class="right-cnt">
					<div class="cnt-title-ctr">
						<div class='cnt-title'>{{industryData.title}}</div>

						<el-button type="primary" icon="el-icon-plus" size="small"
							@click="clickAddIndustry()">新增行业</el-button>
					</div>

					<el-table :data="list" border row-key="id" ref="multipleTable">
						
						<el-table-column label="共性行业" align="center" prop="industry_name" >
							<template v-slot="{ row, $index }">
								<div v-if="row.same" class="dif-industry" @click="clickSameIndustry($index)">{{row.same.industry_name}}
									<img class="checkbox" v-if="row.same.selected == 1" src="@/assets/checkbox_s.png"/>
									<img class="checkbox" v-else src="@/assets/checkbox.png"/>
								</div>
								<div v-else></div>
							</template>
						</el-table-column>
						<el-table-column label="非共性行业（可选）" align="center" prop="major_name">
							<template v-slot="{ row, $index }">
								<div v-if="row.diff" class="dif-industry" @click="clickDiffIndustry($index)">{{row.diff.industry_name}}
									<img class="checkbox" v-if="row.diff.selected == 1" src="@/assets/checkbox_s.png"/>
									<img class="checkbox" v-else src="@/assets/checkbox.png"/>
								</div>
								<div v-else></div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<div class="action-ctr">
				<el-button class="next-btn" type="primary" icon="el-icon-right" size="medium" @click="clickCareer()">下一步</el-button>
			</div>
		</div>

		<el-dialog title="编辑产业" :visible.sync="showGroupIndustryDialog" append-to-body v-if="showGroupIndustryDialog"
			align="center" @close="onGroupDialogClosed">

			<div class="tab-ctr">
				<label v-for="(item,index) in groupAddList"
					:class="['tab-item', index == groupAddIndex ? 'tab-item-s' : '']" :key="index"
					@click="clickAddTab(index)">{{item.name}}</label>
			</div>

			<el-form :inline="true" align="left">
				<el-form-item label="行业门类">
					<el-select v-model="topIndustry" placeholder="请输入关键字" class="select-group-width" filterable remote
						:clearable=true reserve-keyword :remote-method="loadTopIndustryList"
						@change="changeGroupTopIndustry">
						<el-option v-for="item in topIndustryList" :key="item.code" :label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div class="data-table">
				<el-table :data="groupDataList" border>
					<el-table-column prop="parent" label="行业门类" align="center"></el-table-column>
					<el-table-column prop="name" label="行业大类" align="center"></el-table-column>
					<el-table-column label="操作" align="center">
						<template v-slot="{ row }">
							<el-button type="primary" size="small" @click="clickAddGroupIndustry(row.code)"
								v-if="row.isAdd == 2">添加</el-button>
							<el-button type="warning" size="small" @click="clickRemoveGroupIndustry(row.code)"
								v-else-if="row.isAdd == 1">移除</el-button>
						</template>
					</el-table-column>

				</el-table>

				<div class="pagination">
					<pagination v-show="total>0" :total="total" :page.sync="groupQueryParams.page"
						:limit.sync="groupQueryParams.pageSize" @pagination="queryGroupIndustry" />
				</div>
			</div>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseGroupDialog()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getSameIndustryData,
		getTopIndustryList,
		getGroupIndustryList,
		addGroupIndustry,
		delGroupIndustry
	} from "@/api/matrix"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	import { getIndustryData } from "../api/matrix"

	export default {
		name: "Famous",
		data() {
			return {
				title: '',
				majorData: null,
				industryData: null,
				majorSpanMap: {},
				industrySpanMap: {},
				showGroupIndustryDialog: false,
				navList: [{
						'icon': 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13152635-89000603806795123.png',
						'name': '专业群分析',
						'url': 'replace://group'
					},
					{
						'icon': 'http://syzsoss.oss-cn-chengdu.aliyuncs.com/202509/13153102-77494491196988002.png',
						'name': '共性行业',
						'url': ''
					}
				],
				groupAddList: [{
						'name': '未添加',
						'value': 2
					},
					{
						'name': '已添加',
						'value': 1
					},
				],
				groupAddState: 2,
				groupAddIndex: 0,
				topIndustry: '',
				topIndustryList: [],
				groupQueryParams: {
					page: 1,
					pageSize: 10
				},
				groupDataList: [],
				total: 0,
				majorCodes: '',
				sameMap: {},
				list: []
			}
		},
		created() {
			this.initPageData();
		},

		mounted() {
			// this.$nextTick(() => {  
			// 	this.setIndustryDefaultSelected();
			// })

		},

		methods: {
			initPageData() {
				this.requestData();
			},

			requestData() {
				this.groupId = this.$route.query.id;
				getSameIndustryData({
					'group_id': this.groupId,
				}).then(res => {
					console.log('groupId', this.groupId)
					let realData = res.data;
					this.title = realData.title;
					this.majorData = realData.majorData;
					this.industryData = realData.industryData;

					this.majorSpanMap = getSpanMap(this.majorData.list, ['major_name'])
					
					this.list = realData.industryData.list
					
					this.industrySpanMap = getSpanMap(this.list, ['industry_name'])

					this.$nextTick(() => {
						this.setIndustryDefaultSelected();
					})
				});
			},

			setIndustryDefaultSelected() {
				if (isEmpty(this.industryData)) {
					return;
				}

				this.industryData.list.forEach(row => {
					if (row.selected == 1) {
						this.$refs.multipleTable.toggleRowSelection(row, true)
					}
				})
			},

			loadTopIndustryList() {
				if (this.topIndustryList && this.topIndustryList.length > 0) {
					return;
				}

				getTopIndustryList({
					'group_id': this.groupId
				}).then(res => {
					let realData = res.data;
					this.topIndustryList = realData.list;
				});
			},

			clickAddTab(index) {
				this.topIndustry = '';
				// this.groupDataList = []
				this.groupQueryParams.page = 1;
				this.groupAddIndex = index;
				this.groupAddState = this.groupAddList[index]['value']
				this.queryGroupIndustry();
			},

			changeGroupTopIndustry(value) {
				this.groupDataList = []
				this.groupQueryParams.page = 1;
				this.queryGroupIndustry();
			},

			queryGroupIndustry() {
				this.groupQueryParams.group_id = this.groupId;
				this.groupQueryParams.top_code = this.topIndustry;
				this.groupQueryParams.isAdd = this.groupAddState;
				getGroupIndustryList(this.groupQueryParams).then(res => {
					this.groupDataList = res.data.list;
					this.total = res.data.pageData.totalCount;
				});
			},

			clickCareer() {
				let codes = this.getIndustryCodes();
				if (isEmpty(codes)) {
					Message({
						message: '行业为空',
						type: 'error',
						zIndex: 3000
					})
					return;
				}

				// let path = '/industry_data?id=' + this.groupId + '&codes=' + codes;
				let path = '/industry_career?id=' + this.groupId + '&codes=' + codes;
				console.log('path', path)
				this.$router.push(path);
			},
			
			getIndustryCodes(){
				let codeList = [];
				
				for(let i = 0; i < this.list.length; i++){
					let item = this.list[i];
					
					if (item.same && item.same.selected == 1){
						codeList.push(item.same.industry_code)
					}
					
					if(item.diff && item.diff.selected == 1){
						codeList.push(item.diff.industry_code)
					}
				}

				return codeList.join()
			},

			clickIndustry() {
				Message({
					message: '敬请期待',
					type: 'success'
				})
			},

			clickAddIndustry() {
				this.showGroupIndustryDialog = true;
				this.groupDataList = [];
				this.loadTopIndustryList();
				this.queryGroupIndustry();
			},

			clickAddGroupIndustry(code) {
				this.groupQueryParams.group_id = this.groupId;
				this.groupQueryParams.code = code;
				addGroupIndustry(this.groupQueryParams).then(res => {
					this.queryGroupIndustry();
				});
			},

			clickRemoveGroupIndustry(code) {
				this.groupQueryParams.group_id = this.groupId;
				this.groupQueryParams.code = code;
				delGroupIndustry(this.groupQueryParams).then(res => {
					this.queryGroupIndustry();
				});
			},

			clickCloseGroupDialog() {
				this.showGroupIndustryDialog = false;
				this.onGroupDialogClosed();
			},

			onGroupDialogClosed() {
				this.requestData();
			},

			spanMethod({
				row,
				column,
				rowIndex
			}) {
				const colProp = column.property // 当前列字段名
				if (this.majorSpanMap[colProp]) {
					const rowspan = this.majorSpanMap[colProp][rowIndex]
					return {
						rowspan,
						colspan: rowspan === 0 ? 0 : 1
					}
				}
				return {
					rowspan: 1,
					colspan: 1
				}
			},

			industrySpanMethod({
				row,
				column,
				rowIndex
			}) {
				const colProp = column.property // 当前列字段名
				if (this.industrySpanMap[colProp]) {
					const rowspan = this.industrySpanMap[colProp][rowIndex]
					return {
						rowspan,
						colspan: rowspan === 0 ? 0 : 1
					}
				}
				return {
					rowspan: 1,
					colspan: 1
				}
			},

			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)

				if (data) {
					if (data['head'] == 'replace') {
						let url = "/" + data['path'];
						if (data['data'] != null && data['data'].length != 0) {
							url += "?" + data['data'];
						}
						console.log('url', url)
						// this.$router.replace(url);
						this.$router.push(url);
					} else {
						handleRouteProtocal(data)
					}
				}
			},

			handleSelectionChange(rows) {
				this.majorCodes = '';
				for (let i = 0; i < rows.length; i++) {
					if (i > 0) {
						this.majorCodes += ','
					}

					this.majorCodes += rows[i]['major_code']
				}
			},
			
			clickDiffIndustry(index){				
				// 确保 diff 对象存在
				if (!this.list[index] || !this.list[index].diff) return
				
				// 切换选中状态
				const newSelected = this.list[index].diff.selected == 1 ? 2 : 1
				
				// 使用 $set 触发响应式更新
				this.$set(this.list[index].diff, 'selected', newSelected)
			},
			
			clickSameIndustry(index){
				// 确保 diff 对象存在
				if (!this.list[index] || !this.list[index].same) return
				
				// 切换选中状态
				const newSelected = this.list[index].same.selected == 1 ? 2 : 1
				
				// 使用 $set 触发响应式更新
				this.$set(this.list[index].same, 'selected', newSelected)
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "sameIndustry.scss";
</style>